import { type MCPServerInfo } from '../../types';

const MdapiServer: MCPServerInfo = {
  serverId: 'MDAPI',
  name: 'MDAPI',
  slug: 'mdapi',
  description: 'MDAPI MCP Server (NOV)',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'nov_mcp',
    commitSha: '20250626-152515',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['apiBaseUrl', 'oauthTokenUrl', 'clientId', 'clientSecret'],
    properties: {
      apiBaseUrl: {
        type: 'string',
        description: 'API Base URL',
        sensitive: false
      },
      oauthTokenUrl: {
        type: 'string',
        description: 'OAuth token URL for API authentication',
        sensitive: false
      },
      clientId: {
        type: 'string',
        description: 'Client ID for OAuth authentication',
        sensitive: false
      },
      clientSecret: {
        type: 'string',
        description: 'Client Secret for OAuth authentication',
        sensitive: true
      }
    }
  }
};

export default MdapiServer;
